import { useState } from "react";

function MoneyManagementModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Money Management",
      content: [
        "What is Money Management?",
        "Importance of Money Management in Trading & Investing",
        "Common Mistakes in Money Management",
      ],
    },
    {
      title: "Module 2: Setting Financial Goals",
      content: [
        "Defining SMART Goals (Specific, Measurable, Achievable, Relevant, Time-bound)",
        "Short-Term vs. Long-Term Goals",
        "Goal-Based Investing: Aligning Goals with Risk Appetite",
      ],
    },
    {
      title: "Module 3: Risk Management Techniques",
      content: [
        "Understanding Risk vs. Reward",
        "Calculating Risk per Trade",
        "The 1-2% Rule: Limiting Capital Exposure",
        "How to Assess Market Volatility and Its Impact on Risk",
      ],
    },
    {
      title: "Module 4: Position Sizing Strategies",
      content: [
        "Importance of Position Sizing",
        "Fixed Fractional Method: Risking a Fixed Percentage of Capital",
        "Kelly Criterion: Maximizing Growth of Your Capital",
        "Practical Examples of Calculating Position Size",
      ],
    },
    {
      title: "Module 5: Stop-Loss Strategies",
      content: [
        "What is a Stop-Loss Order?",
        "Types of Stop-Loss Orders: Fixed, Trailing, and Mental Stops",
        "Setting Optimal Stop-Loss Levels",
        "Using ATR (Average True Range) for Dynamic Stop-Loss",
      ],
    },
    {
      title: "Module 6: Diversification & Asset Allocation",
      content: [
        "Why Diversification is Key to Risk Management",
        "Building a Diversified Portfolio",
        "Asset Allocation by Age and Risk Tolerance",
        "Sector and Geographic Diversification",
      ],
    },
    {
      title: "Module 7: Leverage and Margin Management",
      content: [
        "Understanding Leverage: Pros and Cons",
        "Calculating Safe Leverage Ratios",
        "Margin Calls: What They Are and How to Avoid Them",
        "Practical Case Studies on Overleveraging",
      ],
    },
    {
      title: "Module 8: Risk-Reward Analysis",
      content: [
        "Understanding the Risk-Reward Ratio",
        "How to Calculate and Use Risk-Reward Ratios",
        "Real-World Examples of High and Low Risk-Reward Trades",
        "Tools and Calculators for Analyzing Risk-Reward",
      ],
    },
    {
      title: "Module 9: Developing a Trading Plan",
      content: [
        "Components of a Solid Trading Plan",
        "Setting Entry, Exit, and Risk Parameters",
        "Adapting Your Plan to Market Conditions",
        "Continuous Improvement: Reviewing and Adjusting Your Plan",
      ],
    },
    {
      title: "Module 10: Maintaining a Trading Journal",
      content: [
        "Why Keeping a Trading Journal is Crucial",
        "What to Include in Your Journal",
        "Analyzing Journal Entries to Improve Performance",
        "Tools and Software for Efficient Trade Tracking",
      ],
    },
    {
      title: "Module 11: Emotional Control and Discipline",
      content: [
        "Psychology of Trading: Fear and Greed",
        "Techniques for Maintaining Emotional Discipline",
        "How to Avoid Overtrading and Revenge Trading",
        "The Role of Mindfulness and Stress Management",
      ],
    },
    {
      title: "Module 12: Practical Tools and Resources",
      content: [
        "Money Management Calculators",
        "Recommended Books and Online Courses",
        "Software Tools for Risk Management",
        "Market Analysis and Research Platforms",
      ],
    },
    {
      title: "Module 13: Case Studies and Real-Life Examples",
      content: [
        "Analyzing Successful Traders' Money Management Techniques",
        "Reviewing Failed Trades and What Went Wrong",
        "Group Discussion: Sharing Personal Experiences",
      ],
    },
    {
      title: "Module 14: Interactive Q&A Session",
      content: [
        "Addressing Common Questions and Concerns",
        "Real-Time Trade Analysis and Feedback",
        "Open Forum for Discussing Strategies",
      ],
    },
    {
      title: "Module 15: Final Assessment and Certification",
      content: [
        "Quiz/Assessment to Test Understanding",
        "Providing a Certificate of Completion",
        "Resources for Continued Learning and Support",
      ],
    },
  ];

  return (
    <div className="container-fluid">
      <div className="container py-5">
        <h1 className="text-center mb-5">Mastering Money Management</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div key={index} className="col-12 col-md-5 mb-3">
              {/* Module Header */}
              <div
                className="p-3 d-flex justify-content-between align-items-center"
                style={{
                  background: "#e9ecef",
                  border: "1px solid #ced4da",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: "18px",
                    transform: openModule === index ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Module Content */}
              {openModule === index && (
                <div
                  className="p-3 mt-2"
                  style={{
                    background: "#ffffff",
                    border: "1px solid #ced4da",
                    borderRadius: "5px",
                  }}
                >
                  {module.content.map((item, i) => (
                    <p key={i} style={{ fontSize: "14px", margin: "5px 0" }}>
                      ➤ {item}
                    </p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MoneyManagementModule;
